import axios from "axios";

const api = axios.create({
	baseURL: "https://goldiphonesbhapi.mecliq.com.br/",
	withCredentials: true,
});

export const openApi = axios.create({
	baseURL: "https://goldiphonesbhapi.mecliq.com.br/"
});

export default api;
